import React, { FC } from 'react';
import { IconType } from '@react-icons/all-files';
import { createUseStyles } from '../../../../../../../theming';
import { ButtonBase } from '@material-ui/core';

interface Props {
  icon: IconType;
  label: string;
  onClick: () => void;
}

const useStyles = createUseStyles({
  root: {
    flexDirection: 'column',
    width: 90,
    height: 90,
    background: '#ececec !important',
    color: '#868585 !important',
    borderRadius: '3px !important',
    fontSize: 12,
    margin: '0 5px 0 0 !important',
    padding: '5px !important',
    border: '1px solid #e6e3e3 !important',
  },
});

const Action: FC<Props> = (props) => {
  const { icon: Icon, label, onClick } = props;
  const classes = useStyles();

  return (
    <ButtonBase className={classes.root} onClick={onClick}>
      <Icon size={25} />
      <div>{label}</div>
    </ButtonBase>
  );
};

export default Action;
